<template>

  <v-app style="background-color:white;margin-top:0px;">
    <!-- <div style="margin-top:-10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr txt">Home</span> / <span style="color:#EA0202" class="txt">Countries</span></p>
     </div> -->
     <div class="kolkata5 res">
         <v-layout row wrap class="container" >
            <v-flex xs12 sm12 md6 lg12 >
                 <h1 style="padding:15px;color:whitesmoke;margin-top: 20px;">Countries</h1>
            </v-flex>
         </v-layout>
     </div>
     <div class="kolkata5 man">
         <v-layout row wrap class="container" style="margin-top:50px">
            <v-flex xs12 sm12 md6 lg12 >
                 <h1 style="padding:15px;color:whitesmoke;">Countries</h1>
            </v-flex>
         </v-layout>
     </div>
     <div >

     <div style="padding-top:-15px">
      <div class="container" style="padding-top:70px;">
        <div class="row" v-if="countries.length>0">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" style="margin-bottom:25px;" v-for="item in countries" :key="item.id">
            <!-- <v-card
            elevation="7"
                      >
                <div class="row" style="margin:0px;background-image: linear-gradient(to right, #E58100, #EA0202);color: whitesmoke;">
                  <div class="col-lg-4 col-md-4 col-sm-12" style="text-align: left;">
                    <img @click="onCountry(item)" :src=item.src style="height: 80px;width: 100px;border: 1px solid;cursor: pointer;" /> 
                  </div>
                  <div class="col-lg-8 col-md-8 col-sm-12">
                    <h5 style="text-align: right;margin-top: 35px;">{{item.countryName}}</h5>
                  </div>
                </div>
                <div class="row" style="margin:0px;cursor: pointer;" @click="onCountry(item)">
                  <div class="col-lg-10 col-md-10 col-sm-10">
                    <h5 style="padding-top:20px;">View Details </h5>  
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2" style="text-align: right;">
                    <v-icon style="padding-top:20px;">forward</v-icon>
                  </div>
                </div>
            </v-card> -->
            <v-card  elevation="10" :style="{backgroundImage: `url(${item.image})`}" class="tourtheme hvr" @click="onCountry(item)">
              <img :src="item.src" style="border-radius:50%;height:50px;width:50px;" />
              <div style="margin:0px;cursor: pointer;" @click="onCountry(item)">
                <h5 class="mytxt" style="background-color:#bb0000;color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 135px;">{{item.countryName}}</h5>
              </div>
            </v-card>

              <!-- <img (click)="onCountry(item)" class="center" [src]="item.src" style="height: 80px;width: 100px;border: 1px solid;cursor: pointer;" />
              <p class="hvr" (click)="onCountry(item)" style="text-align:center;font-size: 16px;color:#002147">{{item.countryName}}</p> -->
            </div>
          </div>
    </div>
       <!-- <h1 style="text-align:center" v-if="countries.length==0">
         Countries will be uploaded soon !</h1> -->
     </div>
    </div>
  </v-app>
 
</template>

<script>
import config from "./../../config.json";
//import carousel from 'vue-owl-carousel';
//import VueEasyLightbox from 'vue-easy-lightbox';
//import GoTop from '@inotom/vue-go-top';

export default {
  components: {
  },
  data() {
    return {
      valid: true,
      loading: false,
      isLoading: false,
      search: null,
      model: null,

      itemAdded: [
        {
          id: 0,
          name: "Home"
        }
      ],

      form: {
        tourPackage: null,
        destination: null
      },

      categories1: [],
      subCategories: [],

      id: 0,
      itemList: null,

      items: [],
      items1: [],

      selectionType: null,
      countries: [],
    };
    
  },
  
   mounted() {
     this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          this.countries.push({
            id: element.id,
            countryName: element.countryName.toUpperCase(),
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image,
            banner: config.API1 + "country/files2/" + element.banner
          })

        }

        console.log(this.countries);
      });
     
   },

 methods: {
   onCountry(item) {
    sessionStorage.setItem("countryName", item.countryName);
    sessionStorage.setItem("image", item.image);
    sessionStorage.setItem("banner", item.banner);
    sessionStorage.setItem("countryId", item.id); 
    ////this.$router.push("/countrydetail/" + item.id );
    if(item.countryName=='UK') {
      this.$router.push("/study-in-uk");
    }
    else if(item.countryName=='DUBAI') {
      this.$router.push("/study-in-dubai");
    }
    else if(item.countryName=='SINGAPORE') {
      this.$router.push("/study-in-singapore");
    }
    else if(item.countryName=='USA') {
      this.$router.push("/study-in-usa");
    }
    else if(item.countryName=='AUSTRALIA') {
      this.$router.push("/study-in-australia");
    }
    else if(item.countryName=='CANADA') {
      this.$router.push("/study-in-canada");
    }
    else if(item.countryName=='GERMANY') {
      this.$router.push("/study-in-germany");
    }

    else if(item.countryName=='NEW ZEALAND') {
      this.$router.push("/study-in-newzealand");
    }
    else if(item.countryName=='EUROPE') {
      this.$router.push("/study-in-europe");
    }
    else if(item.countryName=='FRANCE') {
      this.$router.push("/study-in-france");
    }
    else if(item.countryName=='NETHERLANDS') {
      this.$router.push("/study-in-netherlands");
    }
    else if(item.countryName=='IRELAND') {
      this.$router.push("/study-in-ireland");
    }
   },
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>

.tourtheme {
  height: 220px;
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.tourtheme:hover {
  background-size: 130%;
}


.tourtheme1 {
  border-right: 0.5px solid;
  border-top: 0.5px solid;
  border-bottom: 0.5px solid;
  border-color: #bbb;
  background-color: white;
}
.banner {
  background-image: url('https://cdnimg.webstaurantstore.com/uploads/seo_category/2018/10/commercial-refrigeration_1.jpg');
  background-size: cover;
  height:200px;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.kolkata5 {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('http://www.royalacpaints.com/images/about-us-banner.jpg');
    background-size: cover;
}


.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}

.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}

.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
.zoomimg {
    position: relative;
    overflow: hidden;
}
.location-img {
    position: relative;
}
.location-img:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0px;
    width: 100%;
    opacity: .9;
    background-image: -webkit-linear-gradient(top, currentColor, transparent);
    background-image: linear-gradient(0deg, currentColor 0, transparent);
    color: #000000;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    opacity: .6;
    height: 100%;
}
.text-white {
    color: #fff!important;
}
a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
}
.zoomimg img {
    max-width: 100%;
    -moz-transition: all 0.3s;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    float: left;
    width: 100%;
}
.img-fluid {
    max-width: 100%;
    height: 200px;
}
.location-img-overlay {
    position: absolute;
    bottom: 15px;
    width: 100%;
    padding: 0px 20px;
}
.justify-content-between {
    -ms-flex-pack: justify!important;
    justify-content: space-between!important;
}
.d-flex {
    display: -ms-flexbox!important;
    display: flex!important;
}
.pt-1, .py-1 {
    padding-top: .25rem!important;
}
.mb-0, .my-0 {
    margin-bottom: 0!important;
}
.location-img-overlay h3 a {
    font-size: 20px;
}
</style>
